export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: 'all',
    name: '全部资源',
    icon: 'ri-apps-line',
    description: '浏览91网全部资源分类，发现您需要的所有内容。',
    count: 1280,
  },
  {
    slug: 'resources',
    name: '学习资源',
    icon: 'ri-book-open-line',
    description: '精选在线课程、电子书、学习工具等各类学习资源。',
    count: 356,
  },
  {
    slug: 'tools',
    name: '实用工具',
    icon: 'ri-tools-line',
    description: '效率工具、设计资源、开发工具等实用软件推荐。',
    count: 248,
  },
  {
    slug: 'news',
    name: '行业资讯',
    icon: 'ri-newspaper-line',
    description: '最新行业动态、趋势分析、政策解读等资讯内容。',
    count: 512,
  },
  {
    slug: 'life',
    name: '生活服务',
    icon: 'ri-heart-line',
    description: '生活缴费、出行服务、健康医疗等便民生活服务。',
    count: 164,
  },
];

export interface ResourceItem {
  id: string;
  categorySlug: string;
  title: string;
  description: string;
  image: string;
  tags: string[];
  rating: number;
  users: string;
  link: string;
}

export const resources: ResourceItem[] = [
  {
    id: 'res-001',
    categorySlug: 'resources',
    title: 'Python全栈开发从入门到精通',
    description: '涵盖Python基础、Web开发、数据分析、机器学习的完整学习路径，适合零基础学习者系统掌握编程技能。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20coding%20workspace%20with%20laptop%20showing%20Python%20code%20on%20screen%2C%20minimal%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20soft%20shadows%2C%20educational%20technology%20theme%2C%20professional%20photography%20style&width=800&height=500&seq=res-001&orientation=landscape',
    tags: ['编程', 'Python', '全栈'],
    rating: 4.8,
    users: '12.5万',
    link: '/article/python-fullstack',
  },
  {
    id: 'res-002',
    categorySlug: 'resources',
    title: '2026年AI人工智能学习宝典',
    description: '汇总最新AI技术趋势、深度学习框架教程、大模型应用实战案例，助您把握AI时代机遇。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20concept%20with%20neural%20network%20visualization%2C%20clean%20modern%20design%2C%20soft%20blue-teal%20gradient%20background%2C%20abstract%20technology%20elements%2C%20minimal%20composition&width=800&height=500&seq=res-002&orientation=landscape',
    tags: ['AI', '人工智能', '深度学习'],
    rating: 4.9,
    users: '18.3万',
    link: '/article/ai-learning-2026',
  },
  {
    id: 'res-003',
    categorySlug: 'resources',
    title: '英语学习资源大合集',
    description: '从零基础到高级商务英语，包含听说读写全面训练资源，涵盖雅思托福备考资料。',
    image: 'https://readdy.ai/api/search-image?query=English%20learning%20materials%20on%20a%20clean%20desk%2C%20books%20and%20headphones%2C%20warm%20natural%20light%2C%20minimal%20aesthetic%2C%20educational%20photography%20style&width=800&height=500&seq=res-003&orientation=landscape',
    tags: ['英语', '语言学习', '考试'],
    rating: 4.7,
    users: '9.8万',
    link: '/article/english-resources',
  },
  {
    id: 'res-004',
    categorySlug: 'resources',
    title: '职场技能提升必修课',
    description: 'PPT制作、Excel数据分析、项目管理、沟通表达等核心职场技能一站式学习。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20office%20workspace%20with%20presentation%20slides%20on%20screen%2C%20clean%20minimal%20desk%2C%20natural%20lighting%2C%20corporate%20training%20theme%2C%20warm%20tones&width=800&height=500&seq=res-004&orientation=landscape',
    tags: ['职场', '技能', '办公'],
    rating: 4.6,
    users: '15.2万',
    link: '/article/career-skills',
  },
  {
    id: 'res-005',
    categorySlug: 'tools',
    title: '设计师必备的50个在线工具',
    description: '涵盖配色方案、字体选择、图片处理、原型设计等设计全流程的在线工具合集。',
    image: 'https://readdy.ai/api/search-image?query=Design%20tools%20dashboard%20on%20a%20minimal%20workspace%2C%20color%20palettes%20and%20typography%20samples%2C%20creative%20studio%20atmosphere%2C%20warm%20lighting%2C%20professional%20photography&width=800&height=500&seq=res-005&orientation=landscape',
    tags: ['设计', '工具', '在线'],
    rating: 4.8,
    users: '8.6万',
    link: '/article/designer-tools',
  },
  {
    id: 'res-006',
    categorySlug: 'tools',
    title: '远程办公效率工具包',
    description: '团队协作、视频会议、项目管理、文件共享等远程办公场景的实用工具精选推荐。',
    image: 'https://readdy.ai/api/search-image?query=Remote%20work%20setup%20with%20laptop%20and%20multiple%20screens%2C%20clean%20home%20office%2C%20video%20conference%20on%20display%2C%20warm%20natural%20light%2C%20modern%20minimal%20aesthetic&width=800&height=500&seq=res-006&orientation=landscape',
    tags: ['远程办公', '效率', '协作'],
    rating: 4.7,
    users: '11.4万',
    link: '/article/remote-work-tools',
  },
  {
    id: 'res-007',
    categorySlug: 'news',
    title: '2026年互联网行业趋势展望',
    description: '深入分析2026年互联网行业发展趋势，解读AI、云计算、Web3等热门赛道机遇与挑战。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20trends%20visualization%20with%20abstract%20data%20charts%2C%20clean%20minimal%20design%2C%20warm%20teal%20accents%2C%20professional%20business%20analytics%20theme&width=800&height=500&seq=res-007&orientation=landscape',
    tags: ['趋势', '互联网', '2026'],
    rating: 4.9,
    users: '20.1万',
    link: '/article/tech-trends-2026',
  },
  {
    id: 'res-008',
    categorySlug: 'news',
    title: '数字化转型对企业的影响分析',
    description: '探讨数字化转型如何重塑企业运营模式，分析成功案例与实施策略。',
    image: 'https://readdy.ai/api/search-image?query=Digital%20transformation%20concept%20with%20modern%20office%20technology%2C%20clean%20corporate%20aesthetic%2C%20warm%20ambient%20lighting%2C%20professional%20business%20photography&width=800&height=500&seq=res-008&orientation=landscape',
    tags: ['数字化', '企业', '转型'],
    rating: 4.6,
    users: '7.2万',
    link: '/article/digital-transformation',
  },
  {
    id: 'res-009',
    categorySlug: 'life',
    title: '2026年最受欢迎的在线生活服务',
    description: '盘点和评测2026年最受欢迎的在线生活服务平台，涵盖外卖、出行、购物、医疗等领域。',
    image: 'https://readdy.ai/api/search-image?query=Lifestyle%20mobile%20apps%20displayed%20on%20a%20clean%20surface%2C%20warm%20minimal%20aesthetic%2C%20soft%20natural%20lighting%2C%20modern%20lifestyle%20photography&width=800&height=500&seq=res-009&orientation=landscape',
    tags: ['生活', '服务', '评测'],
    rating: 4.5,
    users: '6.8万',
    link: '/article/online-life-services',
  },
  {
    id: 'res-010',
    categorySlug: 'life',
    title: '城市生活省钱攻略大全',
    description: '收集整理了各城市最实用的省钱技巧和生活秘籍，让您的生活更经济实惠。',
    image: 'https://readdy.ai/api/search-image?query=Smart%20saving%20money%20concept%20with%20piggy%20bank%20and%20coins%20on%20minimal%20desk%2C%20warm%20cozy%20lighting%2C%20clean%20aesthetic%2C%20lifestyle%20photography&width=800&height=500&seq=res-010&orientation=landscape',
    tags: ['省钱', '生活', '攻略'],
    rating: 4.4,
    users: '5.3万',
    link: '/article/city-saving-tips',
  },
  {
    id: 'res-011',
    categorySlug: 'tools',
    title: '自媒体内容创作工具精选',
    description: '视频剪辑、图文排版、素材下载、数据分析等自媒体创作全流程工具推荐。',
    image: 'https://readdy.ai/api/search-image?query=Content%20creator%20workspace%20with%20camera%20and%20editing%20software%2C%20clean%20minimal%20setup%2C%20warm%20lighting%2C%20creative%20professional%20photography&width=800&height=500&seq=res-011&orientation=landscape',
    tags: ['自媒体', '创作', '工具'],
    rating: 4.7,
    users: '13.6万',
    link: '/article/content-creator-tools',
  },
  {
    id: 'res-012',
    categorySlug: 'news',
    title: '新质生产力政策解读与机遇分析',
    description: '全面解读国家新质生产力相关政策，分析各行业机遇与企业发展新方向。',
    image: 'https://readdy.ai/api/search-image?query=Policy%20document%20and%20business%20analysis%20concept%2C%20clean%20professional%20setting%2C%20warm%20ambient%20light%2C%20modern%20corporate%20style%20photography&width=800&height=500&seq=res-012&orientation=landscape',
    tags: ['政策', '新质生产力', '机遇'],
    rating: 4.8,
    users: '16.9万',
    link: '/article/new-productivity-policy',
  },
];